import { render } from "./proof_of_income_manual.html?vue&type=template&id=53bb4911&external"
import script from "./proof_of_income_manual.js?vue&type=script&lang=js&external"
export * from "./proof_of_income_manual.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__